module.exports = __webpack_public_path__ + "static/media/error.2eadc937.png";